//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomNumberInput from '@/components/common/custom-number-input.vue'
import {columnFormatterMixin} from '@/mixins/columnFormatterMixin'
import {customAttributeCodes} from "@/frontend/enums/customAttributeCodes";
import {giftBoxCodes} from "@/frontend/enums/giftBoxCodes";

export default {
  name: 'product-row',
  components: {CustomNumberInput},
  mixins: [columnFormatterMixin],
  props: {
    cartItem: {
      type: Object,
      required: true,
    },
    isCatalogItem: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    giftBoxCodes() {
      return giftBoxCodes
    },
    customAttributeCodes() {
      return customAttributeCodes
    },
  },
  methods: {
    deleteCartItem(id) {
      this.$emit('deleteCartItem', id)
    },
    updateCartItemQuantity({id, quantity}) {
      this.$emit('updateCartItemQuantity', {id, quantity})
    },
  },
}
